import styled from "@emotion/styled";
import { Grid } from "@mui/material";

import { motion } from "framer-motion";

const CenterText = styled.p`
  text-align: center;
`;

const Contact = () => {
  return (
    <motion.div
      key={'about'}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <Grid container rowSpacing={2} columnSpacing={5}>
        <Grid item xs={12} textAlign={"center"}>
          <CenterText>
          If you'd like to reach out about my work, feel free to contact me!
          </CenterText>
          <CenterText>
            I will try my best to get back to you within couple of days.
          </CenterText>
          <CenterText>You can contact me via my socials or email.</CenterText>
        </Grid>
      </Grid>
    </motion.div>
  );
};

export default Contact;
